import {callApi} from '../api'

export const GET_MY_VACATIONS = 'GET_MY_VACATIONS';
export const OPEN_VACATION_REQUEST = 'OPEN_VACATION_REQUEST';
export const CANCEL_VACATION_REQUEST = 'CANCEL_VACATION_REQUEST';

export function getMyVacations(cb) {
    return function (dispatch, getState) {
        let userId = getState().authentication.user._id;
        return callApi(dispatch, getState, 'GET', '/vacations?userId=' +userId, null, GET_MY_VACATIONS, cb);
    }
}

export function openVacationRequest(cb, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'POST', '/vacations', data, OPEN_VACATION_REQUEST, cb);
    }
}

export function cancelVacationRequest(cb, vacationId) {
    return function (dispatch, getState) {
        let data = {
            status: 'canceled'
        };
        return callApi(dispatch, getState, 'PATCH', '/vacations/' + vacationId, data, CANCEL_VACATION_REQUEST, cb);
    }
}



// WEBPACK FOOTER //
// ./src/actions/vacation.js